import type React from 'react';

export const scrollToBottom = (
  containerRef: React.RefObject<HTMLElement | null> | HTMLElement | null,
  delay: number = 0
): void => {
  const scroll = () => {
    const element =
      containerRef && 'current' in containerRef
        ? containerRef.current
        : containerRef;

    if (element) {
      element.scrollTo({
        top: element.scrollHeight,
        behavior: 'smooth',
      });
    }
  };

  setTimeout(scroll, delay);
};
